__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-bob/d56893207ca60bf4c2da3209dd123737b742e605bea3ffa49497d21d/";